/**
 * @generated SignedSource<<7797071b48bbae29eaef41bff303b8bf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GenerateLowHighSuggestionsInput = {
  projectId?: string | null;
  tasks?: ReadonlyArray<LowHighSuggestionInput | null> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type LowHighSuggestionInput = {
  taskId?: string | null;
  roleId?: string | null;
};
export type generateLowHighSuggestionsMutation$variables = {
  input: GenerateLowHighSuggestionsInput;
};
export type generateLowHighSuggestionsMutation$data = {
  readonly generateLowHighSuggestions: {
    readonly suggestions: ReadonlyArray<{
      readonly id: string;
      readonly taskId: string;
      readonly low: number | null;
      readonly high: number | null;
      readonly estimate: number | null;
    } | null> | null;
  } | null;
};
export type generateLowHighSuggestionsMutation = {
  variables: generateLowHighSuggestionsMutation$variables;
  response: generateLowHighSuggestionsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GenerateLowHighSuggestionsPayload",
    "kind": "LinkedField",
    "name": "generateLowHighSuggestions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SuggestedLowHigh",
        "kind": "LinkedField",
        "name": "suggestions",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "taskId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "low",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "high",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "estimate",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "generateLowHighSuggestionsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "generateLowHighSuggestionsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8062554790fb3546c354108ce147903c",
    "id": null,
    "metadata": {},
    "name": "generateLowHighSuggestionsMutation",
    "operationKind": "mutation",
    "text": "mutation generateLowHighSuggestionsMutation(\n  $input: GenerateLowHighSuggestionsInput!\n) {\n  generateLowHighSuggestions(input: $input) {\n    suggestions {\n      id\n      taskId\n      low\n      high\n      estimate\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "88e51dc28fdbd94527f9b7916dc86fd4";

export default node;
